import { render, staticRenderFns } from "./QPageDataTable.vue?vue&type=template&id=81eefe0a&scoped=true&"
import script from "./QPageDataTable.vue?vue&type=script&lang=js&"
export * from "./QPageDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QPageDataTable.vue?vue&type=style&index=0&id=81eefe0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81eefe0a",
  null
  
)

export default component.exports